import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "lotto-result" }
const _hoisted_2 = { class: "result-desc" }
const _hoisted_3 = { class: "result-title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "result-title" }, "당첨번호", -1)
const _hoisted_5 = { class: "result-area" }
const _hoisted_6 = { class: "ball-wrapper" }
const _hoisted_7 = { class: "number" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "bonus-indicator" }, "+", -1)
const _hoisted_9 = { class: "number" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "drwNo", {}, () => [
          _createTextVNode(_toDisplayString(_ctx.lottoResult.drwNo) + " 회차", 1)
        ]),
        _createTextVNode(" (" + _toDisplayString(_ctx.getDateFormat(_ctx.lottoResult.drwNoDate, "yyyy.MM.dd.")) + ") ", 1)
      ])
    ]),
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.drwtNumbers, (number, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass([_ctx.getColorClass(number), "ball"])
          }, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(number), 1)
          ], 2))
        }), 128)),
        _hoisted_8,
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.getColorClass(_ctx.lottoResult.bnusNo), "ball"])
        }, [
          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.lottoResult.bnusNo), 1)
        ], 2)
      ])
    ])
  ]))
}